module.exports = __webpack_public_path__ + "img/album05_15.21fb1496.jpg";